import type { ParentComponent, VoidComponent } from "solid-js";
import { mergeProps, Show } from "solid-js";
import { Icon } from "../../../../components/icon/Icon.tsx";

export const VersionHistoryTrackStartIcon: VoidComponent<{ selected: boolean }> = (props) => (
  <div
    class="rounded-sm p-1.5"
    classList={{
      "bg-surface-active-brand": props.selected,
      "bg-surface-subtle group-hover:bg-surface-hover": !props.selected,
    }}
  >
    <Icon
      classList={{ "icon-brand": props.selected, "icon-primary": !props.selected }}
      name="versionHistory"
      type="solid"
      size="lg"
    />
  </div>
);

export const TrackDot: VoidComponent<{ color: "blue" | "green" | "white" }> = (props) => (
  <div
    class="size-3.5 rounded-full border border-subtle"
    classList={{
      "bg-surface-brand": props.color === "blue",
      "bg-surface-status-success": props.color === "green",
      "bg-surface-default": props.color === "white",
    }}
  />
);

type IconOnTrackProps = {
  head?: boolean;
  tail?: boolean;
};
export const IconOnTrack: ParentComponent<IconOnTrackProps> = (rawProps) => {
  const props = mergeProps({ head: true, tail: true }, rawProps);
  return (
    <>
      <Show when={props.head}>
        <div class="h-2.5 w-px bg-subtle" />
      </Show>
      {props.children}
      <Show when={props.tail}>
        <div class="w-px grow bg-subtle" />
      </Show>
    </>
  );
};
